"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol id=icon-pause viewbox="0 0 16 16"><path fill=currentColor fill-rule=evenodd d="M0 0h6v16H0zm10 0h6v16h-6z"></path></symbol>';
};